import {ControlType} from "./ControlType";
import {PickListItem} from "./PickListItem";

export class Question {
    code: String
    text: String;
    value: String;
    clarifyingAction: Boolean;
    requiresAction: Boolean;
    answerType: String;
    answerText: String;
    questionType: String;
    controlType: ControlType;
    pageNumber: Number;
    dropDownOptions: String[] = [];
    pickListItems: PickListItem[] = [];
    suspectedConditions: PickListItem[] = [];
    pickListSearchEnabled: Boolean;
    disclosureSource: String;
    disclosureAlias: String;
    categoryCode: String;
    categoryDescription: String;
    showPicklist: Boolean;
    showFreeformTextBox: Boolean;
    showSuspectedConditions: Boolean;
    specifiedDisclosureAnswer: String;

    constructor() {
        this.code = '';
        this.text = '';
        this.value = '';
        this.clarifyingAction = false;
        this.requiresAction = false;
        this.answerType = '';
        this.answerText = '';
        this.questionType = '';
        this.controlType = ControlType.YesNo;
        this.pageNumber = 0;
        this.disclosureSource = '';
        this.disclosureAlias = '';
        this.categoryCode = '';
        this.categoryDescription = '';
        this.pickListSearchEnabled = false;
        this.showPicklist = false;
        this.showFreeformTextBox = false;
        this.showSuspectedConditions = false;
        this.specifiedDisclosureAnswer = '';
    }
}
